<template>
  <div id="layout" class="layout">
    <layout-header v-if="!isXueshi" />
    <Sidebar></Sidebar>
    <slot></slot>
    <layout-footer v-if="!isXueshi"/>
  </div>
</template>

<script>
import layoutHeader from './header'
import layoutFooter from './footer'
import Sidebar from '../Sidebar'
export default {
  computed: {
    isXueshi () {
      return this.$route.path.indexOf('/xueshi-iJournal') === 0
    }
  },
  components: {
    layoutHeader,
    layoutFooter,
    Sidebar
  }
}
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  min-width: 1280px;
  min-height: 100%;
  background-color: #F6F6F8;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/index.vue